import { render } from "./Rewards.vue?vue&type=template&id=65a4b335&scoped=true&ts=true"
import script from "./Rewards.vue?vue&type=script&lang=ts"
export * from "./Rewards.vue?vue&type=script&lang=ts"

import "./Rewards.vue?vue&type=style&index=0&id=65a4b335&scoped=true&lang=css"

import exportComponent from "/Users/david/Documents/repos/fancypools-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65a4b335"]])

export default __exports__